import React from 'react';
import { AlarmClock, RotateCw } from 'lucide-react';
import { Button } from '../../ui/button';
import { adminApi } from '../../../lib/adminAuth';
import { fmtDate } from './docUtils';

export const expiryLabel = (left) => (left > 0 ? `${left} day${left === 1 ? '' : 's'} left` : left === 0 ? 'expires today' : `expired ${-left}d ago`);
export const expiryTone = (left) => (left <= 7 ? 'bg-rose-100 text-rose-700' : left <= 15 ? 'bg-amber-100 text-amber-800' : 'bg-sky-100 text-sky-700');

export default function ExpiringBanner({ onRenew, onOpen, refreshKey }) {
  const [rows, setRows] = React.useState([]);
  React.useEffect(() => {
    adminApi.get('/api/admin/contracts/expiring').then((r) => setRows(r.data.contracts)).catch(() => setRows([]));
  }, [refreshKey]);
  if (!rows.length) return null;
  return (
    <div className="soft-card p-4 mb-4 border-l-4 border-amber-400" data-testid="expiring-banner">
      <div className="flex items-center gap-2 mb-3">
        <AlarmClock className="w-5 h-5 text-amber-600" />
        <p className="font-semibold text-[#1a1a2e]">Contracts up for renewal</p>
        <span className="text-xs text-slate-500">{rows.length} within 45 days or expired</span>
      </div>
      <div className="space-y-2">
        {rows.map((r) => (
          <div key={r._id} className="flex flex-wrap items-center gap-3 p-2.5 rounded-xl bg-white border border-slate-100" data-testid={`expiring-row-${r._id}`}>
            <span className={`px-2 py-0.5 rounded-full text-[11px] font-semibold ${expiryTone(r.days_left)}`} data-testid={`expiring-days-${r._id}`}>{expiryLabel(r.days_left)}</span>
            <button type="button" onClick={() => onOpen(r._id)} className="text-sm font-semibold text-slate-800 hover:text-fuchsia-700" data-testid={`expiring-open-${r._id}`}>{r.brand_name || r.client_name}</button>
            <span className="text-xs text-slate-500 flex-1 min-w-[160px]">{r.contract_number} · ends {fmtDate(r.end_date)}</span>
            {r.renewal ? (
              <button type="button" onClick={() => onOpen(r.renewal._id)} className="text-xs font-semibold text-fuchsia-700" data-testid={`expiring-renewal-${r._id}`}>
                Renewal {r.renewal.contract_number} · {r.renewal.status}
              </button>
            ) : (
              <Button size="sm" variant="outline" className="h-8" onClick={() => onRenew(r)} data-testid={`expiring-renew-${r._id}`}><RotateCw className="w-3.5 h-3.5 mr-1" /> Renew</Button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
